<template>
    <div class="projects">
        <router-link v-for="project in projects" :key="project" :to="project">
            <div class="btn" :class="[ $route.params.project === project ? 'btn-active' : '' ]">{{ project }}</div>
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Projects',
    computed: {
        ...mapGetters(['projects', 'project', 'isModal', 'env'])
    },
    created() {
        this.$store.dispatch('getProjects', { currentProject: this.$router.currentRoute.params?.project }).then(() => {
            this.$store.dispatch('resumePendingExcelJob')
        })
    },
    watch: {
        $route(to) {
            if (this.projects.includes(to.params.project)) {
                this.$store.commit('setProject', to.params.project)
                this.$store.commit('setHistoryData', [])
            } else {
                this.$router.push(`${this.project}`)
            }
            this.$store.commit('setIsModal', false)
        },
        '$store.state.env': function (){
          this.$store.dispatch('getData')
        },
        project() {
            if (this.project) {
                this.$route.params.project = this.project
                this.$store.dispatch('getData')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.projects {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 1rem 0;
    @media screen and (min-width: 768px) {
        justify-content: center;
    }
}
.btn {
    display: inline-block;
    margin: 3px;
    background-color: #cce5ff;
    border-color: #b8daff;
    position: relative;
    padding: .25rem .25rem;
    border: 1px solid transparent;
    border-radius: .25rem;
    text-decoration: none;
    color: #fff;
    font-size: 0.8rem;
    &.btn-active {
        background-color: #0069d9;
        border-color: #0062cc;
        box-shadow: 0 0 0 0.2rem rgba(38,143,255,.5);
        color: #fff;
    }
    @media screen and (min-width: 768px) {
        margin: 0.5rem;
        padding: .75rem 1rem;
        font-size: 1rem;
    }
}
</style>
